import { Col } from 'antd';
import type { TLandRelation } from '../../../../../../types/api';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../../Style/DatasetInfo.module.scss';
import { LandWarningInfo } from './LandWarningInfo';
import {
  defineIsSeaArea,
  locationInfoMessages,
  NEAR_LAND,
} from './locationDisplay.utils';
import { PointOutOfGridInfo } from './PointOutOfGridInfo';

interface ILocationInfoDisplay {
  hasDatasets: boolean;
  isLocationAvailable: boolean;
  isWind: boolean;
  landRelation?: TLandRelation | '-';
  waterDepth?: string | number;
  cellSize?: string | number;
}

export const LocationInfoDisplay = ({
  hasDatasets,
  isLocationAvailable,
  waterDepth,
  cellSize,
  isWind,
  landRelation,
}: ILocationInfoDisplay) => {
  const getWindSurfaceType = () => {
    const isSeaArea = defineIsSeaArea(landRelation);

    switch (isSeaArea) {
      case true:
        return 'Sea';
      case false:
        return 'Land';
      default:
        return '-';
    }
  };

  if (!hasDatasets) {
    return (
      <Col span={24} className={styles.InfoCol}>
        <Label
          label={locationInfoMessages.noDatasetFound}
          className={styles.InfoColLabel}
        >
          {''}
        </Label>
      </Col>
    );
  }

  if (isLocationAvailable) {
    const isNearLand = landRelation === NEAR_LAND || landRelation === 2;
    const showLandWarning = isNearLand && !isWind;

    const windPanelInfo = (
      <Label
        label={locationInfoMessages.surfaceType}
        className={styles.InfoColLabel}
      >
        <div className={styles.InfoLabel}>{getWindSurfaceType()}</div>
      </Label>
    );

    return (
      <Col span={12} className={styles.locationInfoContainer}>
        <div className={styles.baseInfo}>
          {isWind && windPanelInfo}
          {!isWind && (
            <Label
              label={locationInfoMessages.waterDepth}
              className={styles.InfoColLabel}
            >
              <div className={styles.InfoLabel}>{waterDepth}</div>
            </Label>
          )}
          <Label
            label={locationInfoMessages.gridCellSize}
            className={styles.InfoColLabelRight}
          >
            <div className={styles.InfoLabel}>{cellSize}</div>
          </Label>
        </div>
        <LandWarningInfo showLandWarning={showLandWarning} />
      </Col>
    );
  }

  const isDataOutOfGrid = waterDepth === '-' && cellSize === '-';

  if (isDataOutOfGrid) {
    return <PointOutOfGridInfo />;
  }

  return <Col span={12} className={styles.locationInfoContainer} />;
};
